import React from 'react'
import { FilterOption } from '../_WMS/FilterComponent'
import { TableHeaderConfigWithType } from '../_EOS/Table'
import { TableColumn } from '../_EOS/GenericTable/types'
import { PositionGrid } from '../../interfaces/Position/Position'
import { PositionAutoCompleter } from './components/PositionAutoCompleter'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../types/filters'
import { YesNoBadge } from '../YesNoBadge/YesNoBadge'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'positionCode',
    label: 'Nombre Posición',
    type: 'custom',
    Component: PositionAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    order: 2,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 3,
    key: 'zoneId',
    label: 'Zona',
    type: 'precreated'
  },
  {
    order: 4,
    key: 'active',
    label: 'Activo',
    type: 'precreated'
  },
  {
    order: 5,
    key: 'typePositionId',
    label: 'Tipo de posición',
    type: 'precreated'
  }
]

export const tableColumns: TableColumn<PositionGrid>[] = [
  { key: 'positionName', title: 'Nombre Posición', sortable: true },
  {
    key: 'typePosition',
    title: 'Tipo Posición',
    sortable: false,
    render: (value) => (value as PositionGrid['typePosition'])?.typePositionDescription || ''
  },
  {
    key: 'warehouse',
    title: 'Almacén',
    sortable: true,
    render: (value) => (value as PositionGrid['warehouse'])?.warehouseName || ''
  },
  {
    key: 'zone',
    title: 'Zona',
    sortable: false,
    render: (value) => (value as PositionGrid['zone'])?.zoneName || ''
  },
  {
    key: 'active',
    title: 'Activo',
    sortable: false,
    render: (value) => React.createElement(YesNoBadge, { value: value as boolean })
  }
]
